import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import storeCart from '@/storeCart'
import storeLanguage from '@/storeLanguage'
import internalBus from '@/internalBus'
import './registerServiceWorker'
import * as ModalDialogs from 'vue-modal-dialogs'
import moment from 'moment'
import VueResource from 'vue-resource'
import merge from 'deepmerge'
import cartServicesMinimal from '@/mixins/services/cartServicesMinimal'
import storeManifest from '@/storeManifest'
// import VueCookie from 'vue-cookie'

// x667034
// Condu2020!

// 77.93.236.124

/* import VuePageTransition from 'vue-page-transition'
Vue.use(VuePageTransition) */

moment.locale('en')
Vue.config.productionTip = false
Vue.use(ModalDialogs)
Vue.use(VueResource)
// Vue.use(VueCookie)
Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true
Vue.http.options.crossOrigin = true

Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'
Vue.http.headers.common['Access-Control-Allow-Methods'] = 'POST, GET, PUT, DELETE, OPTIONS'

/* let c = 0
Vue.http.interceptors.push(function (request) {
  if (request.url.indexOf('refresh') > -1) {
    console.log('c', c)
    if (++c > 3) {
      return request.respondWith({}, {
        status: 401,
        statusText: 'Sogna!'
      })
    }
  }
}) */

Vue.http.interceptors.push(function (_request, next) {
  next(function(response) {
    if (response.status === 401 && response.url.indexOf('/auth/user') === -1) {
      internalBus.$emit('unauthorizedNetworkCall')
    }
  })
})

Vue.http.interceptors.push((_request, next) => {
  internalBus.$emit('networkspy:increment')
  next(() => {
    internalBus.$emit('networkspy:decrement')
  })
});

window.randint = function () {
  let from = 0
  let to = 1
  if (arguments.length === 2) {
    from = arguments[0]
    to = arguments[1]
  } else if (arguments.length === 1) {
    to = arguments[0]
  }
  let r = from + Math.floor(Math.random() * ((to - from) + 1))
  return r
}

window.invertColorCache = window.invertColorCache || {}
window.invertColor = color => {
  if(window.invertColorCache[color]) {
    return window.invertColorCache[color]
  }
  if (!color) {
    return 'white'
  }
  var rgb_color = null
  if (color.startsWith('#')) {
    rgb_color = window.hexToRgb(color)
  }
  if (color.startsWith('rgb(')) {
    rgb_color = window.rgbstringToRgb(color)
  } else {
    var ctx = document.createElement('canvas').getContext('2d'); ctx.fillStyle = color;
    color = ctx.fillStyle
    rgb_color = window.hexToRgb(color)
  }
  if (!rgb_color) {
    return 'white'
  }
  // console.log(color, rgb_color, (rgb_color.r * 299 + rgb_color.g * 587 + rgb_color.b * 114) / 1000)
  let result = (rgb_color.r * 299 + rgb_color.g * 587 + rgb_color.b * 114) / 1000 > 125 ? 'black' : 'white'
  window.invertColorCache[color] = result
  return result
}
window.hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (result) {
    return {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
  }
  result = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(hex)
  return result ? {
      r: parseInt(result[1] + result[1], 16),
      g: parseInt(result[2] + result[2], 16),
      b: parseInt(result[3] + result[3], 16)
  } : null;
}
window.rgbstringToRgb = rgb => {
  var result = /^rgb\(?([\d]{1,3}),([\d]{1,3}),([\d]{1,3})\)$/i.exec(rgb.replace(/\s/g, ''))
  return result ? {
      r: parseInt(result[1]),
      g: parseInt(result[2]),
      b: parseInt(result[3])
  } : null
}

Vue.directive('scrolleffect', {
  bind: function (/*el/*, binding, vnode*/) {
    /* el.classList.add('scrolleffect')
    // let ell = document.createElement('div')
    // ell.classList.add('scrolloverlay')
    // el.appendChild(ell)
    el.addEventListener('scroll', () => {
      let height = el.getBoundingClientRect().height
      let top = el.scrollTop
      let innerheight = el.scrollHeight
      let bottom = innerheight - top - height
      // ell.style.backgroundImage = `linear-gradient(red 0, transparent ${20}px`
      console.log(el.scrollTop, el.scrollHeight, bottom)

      if (top < 2) {
        el.classList.remove('top-content-available')
      } else {
        el.classList.add('top-content-available')
      }
      if (bottom < 2) {
        el.classList.remove('bottom-content-available')
      } else {
        el.classList.add('bottom-content-available')
      }
    }) */
  }
})

Vue.directive('content-attached-on-top', {
  bind: function (el/*, binding, vnode*/) {
    /* var s = JSON.stringify
    var data =
    'name: '       + s(binding.name) + '<br>' +
    'value: '      + s(binding.value) + '<br>' +
    'expression: ' + s(binding.expression) + '<br>' +
    'argument: '   + s(binding.arg) + '<br>' +
    'modifiers: '  + s(binding.modifiers) + '<br>' +
    'vnode keys: ' + Object.keys(vnode).join(', ')
    console.log(data, binding, vnode) */

    // https://caniuse.com/#feat=css-sticky
    /* DETECT IF STICKY IS SUPPORTED:
    var prop = 'position:';
    var value = 'sticky';
    var el = createElement('a');
    var mStyle = el.style;

    let prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
    mStyle.cssText = prop + prefixes.join(value + ';' + prop).slice(0, -prop.length);

    return mStyle.position.indexOf(value) !== -1; */

    Vue.nextTick(() => {
      let parent = el.parentNode
      // if (parent.classList.contains('multi-nav')) {
      while (parent && ['absolute', 'fixed', 'relative'].indexOf(window.getComputedStyle(parent, null).getPropertyValue('position')) === -1) {
        parent = parent.parentNode
      }
      parent = parent || el.parentNode
      let padding = window.getComputedStyle(parent, null).getPropertyValue('padding-top')
      el.style.position = 'sticky'
      el.style.top = '-' + padding
    })
  }
})

Vue.directive('trl', (el, binding/*, vnode*/) => {
  var modifiers = Object.keys(binding.modifiers)
  var lang = modifiers.length ? modifiers[0] : storeLanguage.state.selectedLanguage
  var msg = storeLanguage.state.dictionaries[lang][binding.arg]
  if (msg === undefined) {
    return binding.value ? `[${binding.arg} ${JSON.stringify(binding.value)}]` : `[${binding.arg}]`
  }
  el.innerHTML = msg.replace(/%%[^%]+%%/g, function(all) {
    return binding.value[all.substring(2, all.length-2)] || all
  })
})

Vue.directive('timeago', {
  bind (el, binding) {
    el.rawvalue = binding.value
    el.interval = setInterval(() => {
      el.innerHTML = moment(el.rawvalue).fromNow()
    }, 1000)
  },
  unbind (el) {
    clearInterval(el.interval)
  },
  update (el, binding) {
    /* clearInterval(el.interval)
    el.interval = setInterval(() => {
      el.innerHTML = moment(binding.value).fromNow()
    }, 1000) */
    el.rawvalue = binding.value
  }
})

Vue.directive('clickspace', {
  bind (el, binding) {
    if (!el.getAttribute('tabindex')) {
      el.setAttribute('tabindex', '0')
      el.addEventListener('keypress', evt => {
        if (evt.keyCode === 32 || evt.which === 32) {
          // el.click()
          if (binding.value) {
            binding.value()
          } else {
            el.click()
          }
        }
      })
      if (binding.value) {
        el.addEventListener('click', () => {
          binding.value()
        })
      }
    }
  }
})

/* Vue.directive('placegsearch', {
  bind (el, binding, vnode) {
    loader.load().then(() => {
      console.warn('INIZIALIZZO AUTOCOMPLETE')
      let autocomplete = new window.google.maps.places.Autocomplete(el, {types: ['geocode']})
      autocomplete.addListener('place_changed', () => {
        console.log('api consumed')
        let place = autocomplete.getPlace()
        console.log(place)
        Vue.set(vnode.context, binding.expression, place)
      })
    })
  }
}) */

Vue.filter('lang', function (value, arg, params) {
  if (value) {
    var lang = arg || storeLanguage.state.selectedLanguage
    var msg = storeLanguage.state.dictionaries[lang][value]
    if (msg === undefined) {
      return params ? `[${value} ${JSON.stringify(params)}]` : `[${value}]`
    }
		return msg.replace(/%%[^%]+%%/g, function(all) {
      return params[all.substring(2, all.length-2)] || all
		})
  } else {
    return value
  }
})

Vue.filter('currency', function (value, unit) {
  let val = (value / 1).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (unit || '€')
})

Vue.filter('date', function (value, format) {
  let mom = moment(value)
  if (mom.isValid()) {
    return mom.format(format || 'DD/MM/YYYY')
  }
  return '--/--/----'
})
Vue.filter('time', function (value, format) {
  let mom = moment(value)
  if (mom.isValid()) {
    return mom.format(format || 'HH:mm')
  }
  return '--:--'
})
Vue.filter('datetime', function (value, format) {
  let mom = moment(value)
  if (mom.isValid()) {
    return mom.format(format || 'DD/MM/YYYY HH:mm')
  }
  return '--:--'
})
window.humanFileSize = (number, format) => {
  if (!format) {
    if(number < 1024) {
      format = 'bytes'
    } else if (number >= 1024 && number < 1048576) {
      format = 'KB'
    } else if (number >= 1048576) {
      format = 'MB'
    }
  }


  if (format === 'bytes') {
    return number + 'bytes';
  } else if (format === 'KB') {
    return (number/1024).toFixed(1) + 'KB';
  } else if (format === 'MB') {
    return (number/1048576).toFixed(1) + 'MB';
  }
}
Vue.filter('humanFileSize', function (value, format) {
  return window.humanFileSize(value, format)
})

let isAndroid = /(android)/i.test(navigator.userAgent)
let isMobile = /(mobile)/i.test(navigator.userAgent)
let isIOS = false
if (navigator.userAgent.match(/iPhone/i)) {
    isIOS = true
}
if (navigator.userAgent.match(/iPod/i)) {
    isIOS = true
}

Vue.mixin({
  mixins: [cartServicesMinimal ],
  data () {
    return {
      internalBus,
      store,
      storeCart,
      storeLanguage,
      storeManifest,
      isIOS: isIOS,
      isAndroid: isAndroid && isMobile,
      notifierKey: (Math.random() * 100000).toFixed(0),
      lastPromise: null
      // isDevelopment: process.env.NODE_ENV === 'development'
    }
  },
  computed: {
    isConnected () {
      return store.state.connectionStatus === 'online'
    },
    appIsFocused () {
      return store.state.appIsFocused
    },
    screenWidth () { return store.state.screenSize[0] },
    screenHeight () { return store.state.screenSize[1] },
    isMobile () {
      // console.log(this.isAndroid, this.isIOS, this.screenWidth < 400)
      return this.isAndroid || this.isIOS || this.screenWidth < 400
    },
    isSmall () {
      return this.screenWidth < 600
    },
    manifest () {
      /*var urlRegEx =  
/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
      console.log(storeManifest.state.extraHeader)
      if (storeManifest.state.manifest.extraHeader && !storeManifest.state.loadingHeader && storeManifest.state.manifest.extraHeader.match(urlRegEx)) {
        storeManifest.dispatch({ type: 'downloadHtmlFromUrl', isHeader: true })
      }
      if (storeManifest.state.manifest.extraFooter && !storeManifest.state.loadingFooter && storeManifest.state.manifest.extraFooter.match(urlRegEx)) {
        storeManifest.dispatch({ type: 'downloadHtmlFromUrl', isHeader: false })
      } */
      return storeManifest.state.manifest
    },
    extraHeader () {
      return storeManifest.state.loadingHeader ? null : this.manifest.extraHeader
    },
    extraFooter () {
      return storeManifest.state.loadingFooter ? null : this.manifest.extraFooter
    },
    extraMobilePage () {
      // return storeManifest.state.loadingMobilePage ? null : this.manifest.extraMobilePage
      return storeManifest.state.pageMobile
    },
    paymentsToBeVerified () {
      return store.state.paymentsToBeVerified
    },
    user: {
      get() {
        return this.store.state.user
      },
      set(value) {
        value = { ...value }
        delete value.NotNotifiedPayments
        this.store.commit({ type: 'updateUser', value })
      }
    },
    userProfile: {
      get() {
        return this.store.state.userProfile
      },
      set(value) {
        this.store.commit({ type: 'updateUserProfile', value })
      }
    },
    isLogged: {
      get () {
        return this.user ? !!this.user.Token : false
      },
      set (value) {
        if (!value) {
          this.user = null
          this.userProfile = null
        } else {
          console.log('Can\'t do login through isLogged setter!')
          throw Error('Can\'t do login through isLogged setter!')
        }
      }
    },
    isFullLogged () {
      return this.user ? !!this.user.UserAccountCode : false
    },
    buying: {
      get () {
        return this.store.state.buying
      },
      set (value) {
        this.store.commit({ type: 'updateBuying', value })
      }
    },
    waitingLoginPage: {
      get() {
        return this.store.state.waitingLoginPage
      },
      set(value) {
        this.store.commit({ type: 'updateValue', value, key: 'waitingLoginPage' })
      }
    },
    language: {
      get () {
        /* if (!this.storeLanguage.state.initialized) {
          this.storeLanguage.commit('readFromLocalStorage')
        } */
        if (!this.storeLanguage.state.dictionaries[this.storeLanguage.state.selectedLanguage]) {
          this.storeLanguage.commit({ type: 'updateLanguage', value: 'it-IT' })
        }
        return this.storeLanguage.state.selectedLanguage
      },
      set (value) {
        this.storeLanguage.commit({ type: 'updateLanguage', value })
      }
    },
    dicts () {
			return this.storeLanguage.state.dictionaries
    },
    dict () {
			return this.dicts[this.language]
    },
    dictValueALL () {
      return this.dicts[this.language].ALLM || 'ALL'
    },
    stopRadius: {
      get () {
        if (!this.storeCart.state.initialized) {
          this.storeCart.commit('readFromLocalStorage')
        }
        return this.storeCart.state.stopRadius
      },
      set (value) {
        this.storeCart.commit({ type: 'updateStopRadius', value })
      }
    }
  },
  methods: {
    completeHttpParams (params) {
      if (!params) params = {}
      return merge({
        root: this.manifest.backend,
        headers: {
          // Authorization: 'Basic YXBpOnBhc3N3b3Jk',
          cebId: this.manifest.custom_CEB,
          accessType: this.isMobile ? 'mobile' : 'website', // o 0 e basta?
          cultureName: this.language,
          loginToken: this.isLogged ? this.user.Token : null,
          accessMode: this.isFullLogged ? 'connectedUser' : 'anonymous'
        }
      }, params)
    },
    dictValue (value, lang, opt) {
      // console.log(merge({ a: { b: 'B'}, c: 'C', d: 'D'}, { a: { b: 'b'}, c: 'c'}))
      // console.log(value, lang, opt)
      if (value) {
        if (!!lang && typeof lang === 'object') {
          opt = lang
          lang = null
        }
        var msg = this.dicts[lang || this.language][value]
        if (msg === undefined) {
          return opt ? `[${value} ${JSON.stringify(opt)}]` : `[${value}]`
        }
        return msg.replace(/%%[^%]+%%/g, function(all) {
          return opt[all.substring(2, all.length-2)] || all
        })
      }
      return value
    },
    checkEmailValidity (email) {
      return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/.test(email))
    },
    getCurrentPosition () {
      if(navigator.geolocation) {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject)
        })
      } else {
        console.log("Geo Location not supported by browser")
        return Promise.reject("Geo Location not supported by browser")
      }
    },
    invertColor (c) {
      try {
        return window.invertColor(c)
      } catch (e) {
        console.warn(e)
        return 'red'
      }
    }
  },
  beforeDestroy () {
    if (this.lastPromise) {
      this.lastPromise = null
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
